/** Orb icons for sigils (painted with the shared procedural icon painter). */
import { hashString } from '../../core/rng';
import { SIGILS } from '../../game/build';
import { genericIcon } from '../../ui/icons';

type Glyph = Parameters<typeof genericIcon>[2];

const SIGIL_ART: Record<string, [number, Glyph]> = {
  vendetta: [0xd04848, 'claw'],
  hexed_idol: [0xa860ff, 'star'],
  brutal_edge: [0xff6a3a, 'crescent'],
  battle_fervor: [0xff9a3a, 'charge'],
  steady_hand: [0x5aa0ff, 'lance'],
  ambusher: [0x3fc9a0, 'dash'],
  brawler: [0xd08a40, 'fist'],
  quickening: [0x5ae0ff, 'spiral'],
  overcharge: [0xffd040, 'bolt'],
  bulwark: [0x7aa0d8, 'shield'],
  precision: [0xffe28a, 'orb'],
  apex_mastery: [0xffb040, 'meteor'],
  ironhide: [0x9aa8b6, 'shield'],
  pressure_points: [0x9a70ff, 'shockwave'],
  composure: [0x6cd070, 'buff'],
  atk_down: [0xb83030, 'impact'],
  def_down: [0xb83030, 'shield'],
  speed_down: [0xb83030, 'dash'],
  move_down: [0xb83030, 'spiral'],
};

const FALLBACK: Glyph[] = ['star', 'orb', 'impact', 'crescent', 'shockwave', 'charge', 'spiral', 'claw'];

/** Sigil orb art (square image; panels clip it into a circle). */
export function sigilIcon(id: string): string {
  const art = SIGIL_ART[id];
  if (art) return genericIcon(`sigil:${id}`, art[0], art[1]);
  const h = hashString(id);
  const neg = !!SIGILS[id]?.negative;
  return genericIcon(`sigil:${id}`, neg ? 0xb83030 : 0x406080 + (h & 0x7f7f7f), FALLBACK[h % FALLBACK.length] ?? 'star');
}
